import { graphql, useStaticQuery } from 'gatsby';
import { DeepRequired } from 'react-hook-form';

/**
 *  Provides the data in CMS entry "Einstellungen".
 */
export const useSettings = () => {
	const data = useStaticQuery<Queries.SettingsQuery>(graphql`
		query Settings {
			general: markdownRemark(fileAbsolutePath: { regex: "//einstellungen/allgemein/" }) {
				frontmatter {
					vat
				}
			}
			genericTexts: markdownRemark(
				fileAbsolutePath: { regex: "//einstellungen/generische_texte/" }
			) {
				frontmatter {
					noAppointments
				}
			}
			coursesOrder: markdownRemark(
				fileAbsolutePath: { regex: "//einstellungen/kurse_reihenfolge/" }
			) {
				frontmatter {
					entries {
						courseType
						courses
					}
					otherCourseTypes
				}
			}
			coursesDates: markdownRemark(fileAbsolutePath: { regex: "//einstellungen/kurse_termine/" }) {
				frontmatter {
					hideNoAppointments
				}
			}
			digitalizationOrder: markdownRemark(
				fileAbsolutePath: { regex: "//einstellungen/digitalisierung_reihenfolge/" }
			) {
				id
				frontmatter {
					entries {
						digitalizationParent
						digitalizationChildren
					}
				}
			}
		}
	`);

	if (
		!data.general?.frontmatter ||
		!data.genericTexts?.frontmatter ||
		!data.digitalizationOrder?.frontmatter ||
		!data.coursesOrder?.frontmatter ||
		!data.coursesDates?.frontmatter
	) {
		throw new Error('Required settings data is missing');
	}

	const {
		general: { frontmatter: general },
		genericTexts: { frontmatter: genericTexts },
		digitalizationOrder: { frontmatter: digitalizationOrder },
		coursesOrder: { frontmatter: coursesOrder },
		coursesDates: { frontmatter: coursesDates },
	} = data;

	return {
		general: general as DeepRequired<typeof general>,
		genericTexts,
		coursesOrder: coursesOrder as DeepRequired<typeof coursesOrder>,
		coursesDates,
		digitalizationOrder: digitalizationOrder as DeepRequired<typeof digitalizationOrder>,
	};
};
